export function ComponentForm() {
  setTimeout(function() {
    var messagePosition = -1;
    if ($('.gform_confirmation_wrapper').length > 0) messagePosition = $('.gform_confirmation_wrapper').offset().top;
    if ($('.validation_error').length > 0) messagePosition = $('.validation_error').offset().top;

    if (messagePosition > 0) scrollTo(0, messagePosition - $('header').height());
  }, 1000);
}
